import { Component } from '@angular/core';
import { ModalBaseComponent } from '../../../shared/components/modal-base/modal-base.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiError } from '../../../core/models/common/api-error';
import { FormValidationService } from '../../../core/services/form-validation.service';
import { ModalService } from '../../../core/services/modal.service';
import { Store } from '@ngrx/store';
import { VendorsService } from '../../../core/services/vendors.service';
import { authActions } from 'angular/app/core/store/auth';
import { selectAuthUser } from '../../../core/store/reducers';

@Component({
  selector: 'app-create-payment-method-modal',
  template: `
    <app-modal [modalInstance]="modalInstance" (onOk)="onSubmit()">
      <app-text-input
        label="Nom du mode de paiement"
        name="name"
        [control]="form.controls.name"
      ></app-text-input>
    </app-modal>
  `,
  standalone: false,
})
export class CreatePaymentMethodModalComponent extends ModalBaseComponent {
  sendingData: boolean;
  form = new FormGroup({
    name: new FormControl('', [Validators.required]),
  });

  constructor(
    private formValidationService: FormValidationService,
    private modalService: ModalService,
    private store: Store,
    private vendorsService: VendorsService,
  ) {
    super();
  }

  async onSubmit() {
    if (this.formValidationService.validate(this.form)) {
      try {
        this.modalInstance.saving = true;
        const vendor = await this.vendorsService.storePaymentMethod({
          name: this.form.value.name,
        });

        this.store.dispatch(
          authActions.findCurrentUserSuccess({
            user: { ...this.store.selectSignal(selectAuthUser)(), vendor },
          }),
        );
        this.modalService.close();
      } catch (exception) {
        this.formValidationService.displayApiValidationErrors(
          this.form,
          exception as ApiError,
        );
      } finally {
        this.modalInstance.saving = false;
      }
    }
  }
}
